import { Component, Inject } from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
   selector: 'app-permanent-delete',
   templateUrl: 'confirm-permanent-delete.component.html',
   styleUrls: ['confirm-permanent-delete.component.css']
})
export class ConfirmPermanentDeleteComponent {
   progress: boolean;
   name: any;
   isMultiSelect = false;
   itemSelList: any[] = [];
   selectListId: any[] = [];
   isEmpty: false;
   constructor(private dialogRef: MatDialogRef<ConfirmPermanentDeleteComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
      if (this.data.isMultiSelect) {
         this.isMultiSelect = this.data.isMultiSelect;
         this.isEmpty = this.data.trashEmpty;
         this.itemSelList = this.data.listItem;
         this.selectListId = this.itemSelList;
      } else {
         this.name = {item: data.item.name};
      }
   }
   permanentDelete(deleteButton: MatButton, cancelButton: MatButton) {
      deleteButton.disabled = true;
      cancelButton.disabled = true;
      this.progress = true;
      if (this.isEmpty) {
         this.data.service.deleteAll()
            .subscribe(
               (res) => {
                  this.dialogRef.close(true);
                  this.data.toast.success(res.message);
               },
               error => {
                  this.dialogRef.close();
               });
      }
      if (this.isMultiSelect && !this.isEmpty) {
         this.data.service.multiplePermanentDelete(this.selectListId)
            .subscribe(
               (res) => {
                  this.dialogRef.close(true);
                  this.data.toast.success(res.message);
               },
               error => {
                  this.dialogRef.close();
               });
      } else {
         this.data.service.permanentDelete(this.data.item)
            .subscribe(
               (res) => {
                  this.dialogRef.close(true);
                  this.data.toast.success(res.message);
               },
               error => {
                  this.dialogRef.close();
               });
      }
   }
}
